module.exports = __webpack_public_path__ + "static/media/campus security.2029cf0e.svg";